// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2B7J5","title":"FrontImage_title__2SaWT"};